import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const LoxAndLoadedSuccess = () => {
  const [registration, setRegistration] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    const raw = sessionStorage.getItem('loxRegistration');
    if (raw) {
      try {
        setRegistration(JSON.parse(raw));
      } catch {
        // malformed data — ignore
      }
      sessionStorage.removeItem('loxRegistration');
    }
  }, []);

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: '40px' }}>

          {/* Headline */}
          <h2 className="major" style={{ textAlign: 'center', color: '#4CAF50', marginBottom: '8px' }}>
            You're in! See you on the range 🎯
          </h2>
          <p style={{
            textAlign: 'center',
            fontSize: '0.85em',
            opacity: '0.5',
            marginTop: '0',
            marginBottom: '36px',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
          }}>
            Powered by Range Drills
          </p>

          {/* Order Summary (only if we have sessionStorage data) */}
          {registration && (
            <div style={{
              maxWidth: '520px',
              margin: '0 auto 24px',
              padding: '28px',
              backgroundColor: 'rgba(76, 175, 80, 0.08)',
              borderRadius: '10px',
              border: '1px solid rgba(76, 175, 80, 0.3)',
            }}>
              <h3 style={{ marginTop: '0', marginBottom: '18px', color: '#FF5722', fontSize: '1.1em' }}>
                Registration Summary
              </h3>
              <div style={{ lineHeight: '2', fontSize: '0.97em' }}>
                <div><strong>Name:</strong> {registration.name}</div>
                <div><strong>Tier:</strong> {registration.tier}</div>
                <div><strong>Amount Paid:</strong> ${registration.amount}</div>
              </div>
            </div>
          )}

          {/* Event Details */}
          <div style={{
            maxWidth: '520px',
            margin: '0 auto 24px',
            padding: '28px',
            backgroundColor: 'rgba(27, 31, 34, 0.85)',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.15)',
          }}>
            <h3 style={{ marginTop: '0', marginBottom: '18px', color: '#FF5722', fontSize: '1.1em' }}>
              Event Details
            </h3>
            <div style={{ lineHeight: '2', fontSize: '0.97em' }}>
              <div>📅 <strong>When:</strong> Second Monday of every month, 6–8 PM</div>
              <div>📍 <strong>Where:</strong> Mission Ridge, Plano TX</div>
            </div>
            <p style={{ marginTop: '16px', marginBottom: '0', fontSize: '0.88em', opacity: '0.7' }}>
              A confirmation receipt was sent to your email by Stripe. See you at the range!
            </p>
          </div>

          {/* Back to Home */}
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <button
              onClick={() => navigate('/')}
              style={{
                padding: '12px 36px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#FF5722',
                color: '#fff',
                fontSize: '1em',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e64a19';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(255, 87, 34, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#FF5722';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              Back to Home
            </button>
          </div>

        </div>
      </section>
    </Layout>
  );
};

export default LoxAndLoadedSuccess;
